import script from "./TabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TabBar.vue?vue&type=script&setup=true&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=bfd5b922&scoped=true&lang=less"

import exportComponent from "/Users/swdz/devPhp/hbx_code/chatWeb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bfd5b922"]])

export default __exports__